import styled from 'styled-components';

export const MinimalTab = styled.button`
  background: none;
  border: none;
  color: ${(props) =>
    props.active ? 'var(--pd-dark-text-color)' : 'var(--pd-light-text-color)'};
  font-size: 0.9rem;
  font-weight: 500;
  position: relative;
  font-family: var(--text-font);
  cursor: pointer;
  border: 2px solid rgba(0, 0, 0, 0);
  border-radius: 3px;
  :focus-visible {
    border-color: var(--pd-primary-color);
  }
`;

export const ActiveIndicator = styled.div`
  position: absolute;
  margin: auto;
  bottom: -0.9rem;
  left: 0;
  right: 0;
  background-color: #000;
  width: 7px;
  height: 7px;
  border-radius: 100px;
  pointer-events: none;
`;

export const BadgeIndicator = styled.div`
  position: absolute;
  min-width: 1rem;
  height: 1rem;
  right: -12px;
  left: auto;
  top: -12px;
  color: white;
  background-color: #ef4331;
  border-radius: 25px;
  text-align: center;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0.4rem;
`;

export const BadgeNumber = styled.span`
  color: white;
  font-size: 0.8rem;
  text-align: center;
`;
